import { useMutation } from '@apollo/react-hooks';
import { ApolloError } from 'apollo-boost';
import { logoutAndRedirect } from '../../core/auth';

export const useMutationHook = (QUERY: any, onCompleteFunc: Function, onErrorFunc: Function) => {
    const [callMutation, { loading, error, data }] = useMutation(QUERY, {
        onError({ graphQLErrors, networkError }: ApolloError) {
            graphQLErrors?.map((eachError: any): void => {
                if (eachError?.statusCode === 401) {
                    logout();
                }
                // console.log(eachError.message.split(':')[1]);
                const errorMessage = eachError.message.split(':');
                eachError.message = errorMessage[errorMessage.length > 1 ? 1 : 0];
                return null;
            });
            onErrorFunc({ graphQLErrors, networkError });
        },
        onCompleted(result) {
            onCompleteFunc(result)
        }
    });
    return {
        callMutation,
        loading,
        error,
        data
    }
}

const logout = () => {
    logoutAndRedirect();
}

// http://localhost:4201/user/confirm-email/58081b21-7316-4147-b9e5-93c3dbf93681